import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteSetupAuditTrailViewsRequest = {
	id: number;
};

export const deleteSetupAuditTrailViews = createDeleteEndpoint<DeleteSetupAuditTrailViewsRequest>(
	({ id }) => `/api/v3/setup-audit-trail/views/${id}`
);
